module.exports = "<div class=\"idle-backdrop\" *ngIf=\"idleState\">\r\n    <p class=\"idle-message\"><strong>Session is Ending In</strong></p>\r\n    <p class=\"idle-message\"><strong>{{idleStateMessage}} Seconds</strong></p>\r\n    <p>Tap the screen to continue.</p>\r\n</div>\r\n\r\n<div id=\"main-stage\" class=\"main-stage\">\r\n  <div class=\"logo\">\r\n    <img class=\"logo-img\" src=\"assets/logo-01.svg\" alt=\"Gift Surplus\">\r\n  </div>\r\n  <router-outlet></router-outlet>\r\n  <div class=\"bottom-background\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main